import z from 'zod';
import { userSchema } from '@pages/Users/schemas/users.schema';
import { PASSWORD_RULES } from '../constants/resetPassword.constant';

const resetPasswordFormSchema = z
  .object({
    password: z.string().superRefine((val, ctx) => {
      PASSWORD_RULES.forEach((rule) => {
        if (!rule.test(val)) {
          ctx.addIssue({
            path: [rule.id],
            code: 'custom',
            message: rule.message
          });
        }
      });
    }),
    confirmPassword: z.string()
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords did not match',
    path: ['confirmPassword']
  });

const resetPasswordSchema = z.object({
  newPassword: z.string(),
  token: z.string()
});

const tokenVerificationSchema = z.object({
  token: z.string()
});

const tokenVerificationResponseSchema = userSchema.pick({
  email: true,
  id: true,
  createdAt: true,
  name: true
});

export {
  resetPasswordFormSchema,
  resetPasswordSchema,
  tokenVerificationSchema,
  tokenVerificationResponseSchema
};
